module.exports = __webpack_public_path__ + "img/newsImg3-10.baeb2729.png";